module.exports = __webpack_public_path__ + "img/53.773c5524.jpg";